import script from "./DebugPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DebugPage.vue?vue&type=script&lang=ts&setup=true"

import "./DebugPage.vue?vue&type=style&index=0&id=a99a6c5c&lang=scss"

const __exports__ = script;

export default __exports__